<template>

  <div>
    <b-card border-variant="info" class="text-center">
      <template v-slot:header>
        <div>教師あり学習データ：Kitカメラ画像</div>
      </template>
      <div class="smallFont">
        学習データ種別：
        <b-form-select id="selectKitData" size="sm" v-model="l_kitDataType" class="dataselect">
          <option value='marubatu'>マルバツ</option>
          <option value='tateyoko'>タテヨコ</option>
        </b-form-select>
        <b-button variant="outline-primary" size="sm" @click="loadData()">Load</b-button>
      </div>
      <div v-if="progressDiv">
        <br/>
        <div class="progText"><strong>Loading...<b-spinner small variant="danger" label="Small Spinner" type="grow"></b-spinner>【{{progNum}}/2000】</strong></div>
        <div>
          <b-progress :value="progValue" max="100" striped animated></b-progress>
        </div>
        <br/>
      </div>
      <div v-if="!progressDiv">
        <br/>
        <div class="smallFont" v-if="progValue==100"><font color=red><strong>【2000枚(各Label1000枚) Load完了】</strong></font></div>
        <div class="smallFont" v-if="progValue==0">予め取得したKitカメラ画像(2000枚)となります<br/>（環境等により数秒〜数分かかります）</div>
        <br/>
      </div>
      <div id="imgss"></div>
    </b-card>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios' // Ajax通信ライブラリ

export default {
  name: 'inputkitdata',
  data () {
    return {
      progressDiv: false,
      progNum: 0,
      progValue: 0
    }
  },
  computed: {
    ...mapState([ 'samplebtn', 'kitDataType', 'iimages' ]),
    l_kitDataType: {
      get () {
        return this.kitDataType
      },
      set (value) {
        this.$store.dispatch('setKitdata', value)
      }
    }
  },
  methods: {
    loadData () {
      // 処理開始
      this.progressDiv = true
      // Inputデータ修正
      if (this.l_kitDataType === 'marubatu') {
        this.$store.dispatch('updLabel', {in_id: 0, in_label: 'マル'})
        this.$store.dispatch('updLabel', {in_id: 1, in_label: 'バツ'})
      } else {
        this.$store.dispatch('updLabel', {in_id: 0, in_label: 'タテ'})
        this.$store.dispatch('updLabel', {in_id: 1, in_label: 'ヨコ'})
      }
      // データ取得
      const getUrl = '/data/' + this.l_kitDataType + '1000.txt'
      // const getUrl = 'https://ail.socinno.com/data/' + this.l_kitDataType + '1000.txt'
      // const getUrl = 'http://160.16.208.20/data/' + this.l_kitDataType + '1000.txt'
      axios.get(getUrl)
        .then(function (response) {
          // handle success(axiosの処理が成功した場合に処理させたいことを記述)
          this.handleData(response, 0)
        }.bind(this)).catch(function (error) {
          // handle error(axiosの処理にエラーが発生した場合に処理させたいことを記述)
          console.log(error)
          this.setMessage(error)
        }.bind(this)).finally(function () {
          // always executed(axiosの処理結果によらずいつも実行させたい処理を記述)
        })
    },
    async handleData (resdata, jobType) {
      // console.log(resdata.data[0].img_data)
      const imgss = document.getElementById('imgss')
      // 一旦Canvasデータ削除
      while (imgss.lastChild) {
        imgss.removeChild(imgss.lastChild)
      }
      // Canvasデータ追加
      for (let i = 0; i < 2000; i++) {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = 28
        canvas.height = 28
        canvas.id = 'canvas' + String(i + 1)
        canvas.style = 'margin: 2px; outline: black 1px solid;'
        // 画像をcanvasに設定
        var imgData = null
        if (jobType === 0) {
          imgData = resdata.data[i].img_data
        } else {
          imgData = this.iimages[i].img_data
        }
        const img = await this.loadImage(imgData)
        ctx.drawImage(img, 0, 0)
        if (jobType === 0) {
          this.$store.dispatch('setImage', {
            s_in: resdata.data[i].in_id,
            s_img: resdata.data[i].img_num,
            s_data: canvas.toDataURL()
          })
        }
        imgss.appendChild(canvas)
        this.progNum = i
        this.progValue = Math.ceil(i / 2000 * 100)
      }
      this.progValue = 100
      this.progressDiv = false
    },
    loadImage (dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = (e) => reject(e)
        img.src = dataUrl
      })
    },
    setMessage (msg) {
      this.$store.dispatch('setMessage', msg)
    },
    async refreshLoadImage () {
      // 処理開始
      this.progressDiv = true
      await this.handleData(null, 1)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.dataselect {
  width: 100px;
}
.progText {
  color: red;
}
.card-body {
  padding: 5px 5px 0 5px;
}
#imgss {
  max-height: 215px;
  overflow: auto;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/InputKitdata.vue